<template>
  <div class="login-container">
    <div v-if="isLoading" class="loading">
      <div class="loading-spinner"></div>
      <p>Checking authentication status...</p>
    </div>
    <div v-else>
      <h1>Welcome to CodeShipWatch</h1>
      <p>Please sign in to continue</p>
      <button @click="signInWithGoogle" class="google-btn" :disabled="isLoading">
        <img src="../assets/google-logo.svg" alt="Google Logo">
        Sign in with Google
      </button>
    </div>
  </div>
</template>

<script>
import { Auth } from '@aws-amplify/auth'
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'

export default {
  name: 'Login',
  setup() {
    const router = useRouter()
    const isLoading = ref(true)

    const checkAuthState = async () => {
      try {
        await Auth.currentAuthenticatedUser()
        router.push('/')
      } catch {
        isLoading.value = false
      }
    }

    const signInWithGoogle = async () => {
      try {
        isLoading.value = true
        await Auth.federatedSignIn({ provider: 'Google' })
      } catch (error) {
        console.error('Error signing in:', error)
        isLoading.value = false
      }
    }

    onMounted(() => {
      checkAuthState()
    })

    return {
      isLoading,
      signInWithGoogle
    }
  }
}
</script>

<style scoped>
.login-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: #f5f5f5;
}

h1 {
  color: #333;
  margin-bottom: 1rem;
}

p {
  color: #666;
  margin-bottom: 2rem;
}

.google-btn {
  display: flex;
  align-items: center;
  padding: 10px 20px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: white;
  cursor: pointer;
  transition: background-color 0.3s;
}

.google-btn:hover:not(:disabled) {
  background-color: #f8f8f8;
}

.google-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.google-btn img {
  width: 18px;
  height: 18px;
  margin-right: 10px;
}

.loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style> 